const supportsContainerQueries = "container" in document.documentElement.style;

if (!supportsContainerQueries) {
  import("./libraries/cqfill.min");
}

import $ from "jQuery";
import "what-input";

/*
  LIBRARY IMPORTS
  Utilities, plugins, and helpers that aren't tied to a specific component.
*/
import keyboardAccessibility from "./libraries/keyboard-accessibility";
import linkContainer from "./libraries/link-container";

/*
  COMPONENT IMPORTS
  For specific components or collections of components only.
*/
import siteHeader from "./components/site-header";
import scrollInAnimations from "./components/scroll-in-animations";
import sidebarLinks from "./components/sidebar-links";
import accordion from "./components/accordion";
import filtersAccordion from "./components/filters-accordion";
import filtersAccordionFacets from "./components/filters-accordion-facets";
import carousel from "./components/carousel";
import thumbnailImageGrid from "./components/thumbnail-image-grid";
import table from "./components/tables";


// easy console access to JQuery through '$';
window.$ = $;


// FOUC on-fully-loaded make the page visible:
addEventListener('load', (e) => {
  document.documentElement.style.visibility = 'visible';
});


/* INITIALIZATION of modules */
$(() => {
  $('body').addClass("document-ready");

  /* Higher priority first, lower priority later */
  siteHeader();
  keyboardAccessibility();
  scrollInAnimations();
  sidebarLinks();
  linkContainer();

  filtersAccordion();
  carousel();
  accordion();
  thumbnailImageGrid();
  table();
});

Drupal.behaviors.usbg = {
  attach: function () {
    filtersAccordionFacets();
  }
}

// Global JS and utility functions, etc.
// ---

function observeFocus() {

  document.addEventListener('focusin', function() {
    const activeEl = document.activeElement;

    const tag = (activeEl.tagName).toLowerCase();
    let classes = activeEl.className;
    classes = classes.split(' ');
    classes = classes.join('.');

    console.log(tag + (classes ? '.' : '') + classes);
  }, true);

}
